import {
  exampleCampaigns,
  campaignResultsData,
  filterOptions
} from './data';

// Using static data instead of API calls for now
export async function fetchBootstrap() {
  // Simulate a small delay to mimic network request
  await new Promise(resolve => setTimeout(resolve, 100));
  
  return {
    exampleCampaigns,
    campaignResultsData,
    filterOptions
  };
}
